import { render, staticRenderFns } from "./SurgeryPatient.vue?vue&type=template&id=c78b3cc8&scoped=true"
import script from "./SurgeryPatient.vue?vue&type=script&lang=js"
export * from "./SurgeryPatient.vue?vue&type=script&lang=js"
import style0 from "./SurgeryPatient.vue?vue&type=style&index=0&id=c78b3cc8&prod&lang=scss&scoped=true"
import style1 from "./SurgeryPatient.vue?vue&type=style&index=1&id=c78b3cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78b3cc8",
  null
  
)

export default component.exports